import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { RootState } from "../../configureStore";

const selectState = (state: RootState) => state.editContractorDrawer;

const makeSelectOpen = createDraftSafeSelector(selectState, (state) => state.open);
const makeSelectLoading = createDraftSafeSelector(selectState, (state) => state.loading);

const makeSelectContractor = createDraftSafeSelector(selectState, (state) => state.contractor);

export { selectState, makeSelectOpen, makeSelectLoading, makeSelectContractor };
